import { useMemo } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import { getShortDateFormat } from "~/utils/date.jsx";
import { getPersonalizedDateFormat, getPersonalizedTimeFormat } from "../../store/selectors/selector.configOptions.jsx";
import useAcSelectDate from "../Hooks/useAcSelectDate.jsx";

export const FormatLocalDateTime = ({ value, long }) => {
  const dateFormat = useSelector(getPersonalizedDateFormat);
  const timeFormat = useSelector(getPersonalizedTimeFormat);
  const { today } = useAcSelectDate();

  const formattedValue = useMemo(() => {
    const date = moment.unix(value);

    const finalDateFormat = !long && date.isSame(today, "year") ? getShortDateFormat(dateFormat) : dateFormat;

    return date.format(`${finalDateFormat}, ${timeFormat}`);
  }, [value, long, today, dateFormat, timeFormat]);

  return formattedValue;
};

FormatLocalDateTime.propTypes = {
  value: PropTypes.number.isRequired,
  long: PropTypes.bool,
};

FormatLocalDateTime.defaultProps = {
  long: false,
};
